import { Roles } from '@/app/core/auth/role';
import { SessionService } from '@/app/core/services/session.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {}

  goBack(): void {
    const isLoggedIn = this.sessionService.isLoggedIn();

    if (!isLoggedIn) {
      this.router.navigate(['/auth/sign-in']);
      return;
    }

    const role = this.sessionService.getUserRole();

    // The admin app only has a system-admin dashboard. Anything else
    // (MERCHANT, USER, unknown) means this account has no business
    // being here — log them out and send to sign-in instead of routing
    // to a /user/dashboard that doesn't exist in this app.
    if (role === Roles.SYSTEM_ADMIN) {
      this.router.navigate(['/system-admin/dashboard']);
      return;
    }

    this.sessionService.logout();
  }
}
